module.exports = __webpack_public_path__ + "static/img/btn_shenhe_nor.b119b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_shenhe_nor.png
// module id = s3IL
// module chunks = 1